export default __webpack_public_path__ + "static/media/redblu-logo.404eaa4b.svg";